export type AllocationApiRow = {
  cargoId?: number;
  allocatedQuantity?: number;
};

export type RouteAllocationsBundle = {
  routeId: number;
  allocations: AllocationApiRow[];
};

/** Суммы по маршрутам без quantity груза (available считает UI). */
export type CargoAllocationCore = {
  inRoutesTotal: number;
  byRoute: { routeId: number; amount: number }[];
};

/**
 * @deprecated CARGO-L3 — replaced by CargoLifecycleProjectionClient / GET lifecycle-projection.
 * Legacy sums raw allocatedQuantity (ignores closedAt and deliveredQuantity).
 */
export function buildCargoAllocationIndex(
  routeResults: RouteAllocationsBundle[]
): Map<number, CargoAllocationCore> {
  const totals = new Map<number, number>();
  const byRoute = new Map<number, { routeId: number; amount: number }[]>();

  for (const { routeId, allocations } of routeResults) {
    const perCargo = new Map<number, number>();
    for (const row of allocations) {
      const cid = Number(row.cargoId);
      const q = Number(row.allocatedQuantity ?? 0);
      if (!Number.isFinite(cid)) continue;
      perCargo.set(cid, (perCargo.get(cid) ?? 0) + q);
    }
    perCargo.forEach((amount, cid) => {
      if (!Number.isFinite(amount) || amount <= 0) return;
      totals.set(cid, (totals.get(cid) ?? 0) + amount);
      const list = byRoute.get(cid) ?? [];
      list.push({ routeId, amount });
      byRoute.set(cid, list);
    });
  }

  const out = new Map<number, CargoAllocationCore>();
  const idSet = new Set<number>();
  totals.forEach((_, cid) => idSet.add(cid));
  byRoute.forEach((_, cid) => idSet.add(cid));
  idSet.forEach((cid) => {
    const inRoutesTotal = totals.get(cid) ?? 0;
    const sortedRoutes = [...(byRoute.get(cid) ?? [])].sort((a, b) => a.routeId - b.routeId);
    out.set(cid, { inRoutesTotal, byRoute: sortedRoutes });
  });
  return out;
}

export function breakdownWithQuantity(
  index: Map<number, CargoAllocationCore>,
  cargoId: number,
  quantity: number
): { inRoutesTotal: number; available: number; byRoute: { routeId: number; amount: number }[] } {
  const core = index.get(cargoId);
  const inRoutesTotal = core?.inRoutesTotal ?? 0;
  const q = Number(quantity ?? 0);
  return {
    inRoutesTotal,
    available: Math.max(0, q - inRoutesTotal),
    byRoute: core?.byRoute ?? []
  };
}

export function cargoDistributionStatusLabel(
  allocated: number,
  quantity: number
): 'free' | 'partial' | 'full' {
  const q = Number(quantity ?? 0);
  const a = Number(allocated ?? 0);
  if (a <= 0) return 'free';
  if (q > 0 && a >= q) return 'full';
  if (a < q) return 'partial';
  return 'full';
}
